import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, FileText, Play } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AvailableExams = () => {
  const { t } = useTranslation();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const response = await axios.get(`${API}/student/exams`);
      setExams(response.data);
    } catch (error) {
      console.error('Error fetching exams:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="available-exams">
      <div>
        <h2 className="text-3xl font-bold text-gray-900">{t('availableExams')}</h2>
        <p className="text-gray-600 mt-1">{exams.length} {t('exams')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {exams.length === 0 ? (
          <Card className="col-span-full shadow-md">
            <CardContent className="pt-6 text-center text-gray-500">
              {t('noExamsAvailable')}
            </CardContent>
          </Card>
        ) : (
          exams.map((exam, index) => (
            <Card key={exam.id} className="shadow-lg card-hover border-0" data-testid={`exam-card-${index}`}>
              <CardHeader className="bg-gradient-to-r from-cyan-50 to-indigo-50">
                <CardTitle className="text-lg">{exam.title}</CardTitle>
              </CardHeader>
              <CardContent className="pt-6 space-y-4">
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <FileText className="h-4 w-4" />
                    <span>{exam.question_ids.length} {t('questionsCount')}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Clock className="h-4 w-4" />
                    <span>{exam.duration_minutes} {t('minutes')}</span>
                  </div>
                </div>

                <Link to={`/student/exams/${exam.id}`}>
                  <Button data-testid={`take-exam-${index}`} className="w-full bg-gradient-to-r from-cyan-600 to-indigo-600">
                    <Play className="h-4 w-4 mr-2" />
                    {t('takeExam')}
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default AvailableExams;